import logo from './img/logo.svg';
import main1 from './img/Home/main1.png';
import main2 from './img/Home/main2.png';
import main3 from './img/Home/main3.png';
import main4 from './img/Home/main4.png';

export const images = [
    logo,main1,main2,main3,main4
];